export const ACSTYPE_TITLE = "Title";
export const ACSTYPE_SUBTITLE = "Subtitle";
export const ACSTYPE_CONTRIBUTOR = "Contributor";
export const ACSTYPE_INTRO = "Intro";
export const ACSTYPE_MAIN_IMG = "Main Image";

export const ACSTYPE_SEC_TITLE = "H1";
export const ACSTYPE_PARAGRAPH = "Paragraph";
export const ACSTYPE_QUOTE = "Quote";
export const ACSTYPE_SEC_SUBTITLE = "H2";

export const ACSTYPE_IMAGE = "Image";
export const ACSTYPE_VIDEO = "Video";
export const ACSTYPE_AUDIO = "Audio";
export const ACSTYPE_SEP = "Separator";

export const ACSTYPE_GALLERY = "Gallery";
export const ACSTYPE_MOSAIC = "Mosaic";
export const ACSTYPE_PREFACE = "Preface";
